import React from "react";

const Info = (props) => {
  return <p className="info-icon" onClick={props.onClick}>i</p>;
};

export default Info;
